import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import ScrollToTop from "@/components/base/ScrollToTop";
import { useState } from "react";

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formMessage, setFormMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus("loading");
    setFormMessage("");

    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus("success");
      setFormMessage("留言已发送，我们会尽快回复您！");
      form.reset();
      return;
    }

    const formData = new FormData(form);
    formData.delete("phone_alt");

    try {
      const res = await fetch("https://readdy.ai/api/form/d9th1et3pcjqs2fcse50", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed.code === "OK") {
        setFormStatus("success");
        setFormMessage("留言已发送，我们会尽快回复您！");
        form.reset();
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (errMsg.includes("spam") || errMsg.includes("form data is spam")) {
          setFormStatus("success");
          setFormMessage("留言已发送，我们会尽快回复您！");
          form.reset();
        } else {
          setFormStatus("error");
          setFormMessage(errMsg || "发送失败，请稍后重试");
        }
      }
    } catch {
      setFormStatus("error");
      setFormMessage("网络错误，请检查网络后重试");
    }
  };

  const faqs = [
    {
      q: "羞羞色漫是什么？",
      a: "羞羞色漫是一个精选成人漫画在线阅读平台，汇聚海量高质量漫画资源，涵盖恋爱、奇幻、都市、悬疑、搞笑、校园、古风等多种题材，致力于为18岁以上成年用户提供高清流畅的漫画阅读体验。",
    },
    {
      q: "羞羞色漫的漫画资源更新频率如何？",
      a: "我们保持每日更新的频率，确保读者能够及时追更到最新内容。热门作品更是保持与原作者同步更新的节奏，让您不会错过任何精彩剧情。",
    },
    {
      q: "如何在羞羞色漫上阅读漫画？",
      a: "只需访问我们的网站，浏览分类或搜索您喜欢的漫画，点击即可在线阅读。无需下载任何软件，支持电脑、手机、平板等多端访问，随时随地畅享阅读。",
    },
    {
      q: "羞羞色漫是否免费？",
      a: "羞羞色漫提供大量免费漫画资源供读者阅读。部分精选内容可能需要订阅会员，但我们会持续提供丰富的免费内容，让每一位读者都能享受漫画的乐趣。",
    },
    {
      q: "如何联系羞羞色漫？",
      a: "您可以通过本页面下方的联系表单与我们取得联系，或发送邮件至我们的官方邮箱。我们会在24小时内回复您的咨询。",
    },
  ];

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[{ label: "首页", href: "/" }, { label: "关于我们" }]}
        />

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-heading text-foreground-950 text-center mb-4">
              关于羞羞色漫
            </h1>
            <p className="text-sm text-foreground-500 text-center max-w-2xl mx-auto mb-12">
              精选漫画资源汇聚平台，为您提供极致阅读体验
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
              <div className="bg-background-100 rounded-lg p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-full mb-4">
                  <i className="ri-book-read-line text-xl text-primary-500"></i>
                </div>
                <h2 className="text-lg font-heading text-foreground-900 mb-3">
                  品牌介绍
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  羞羞色漫创立于2020年，是国内领先的成人漫画在线阅读平台。我们秉持"精选优质内容，打造极致阅读体验"的理念，为18岁以上的成年读者提供海量高清漫画资源。经过多年的发展，羞羞色漫已成为深受读者信赖和喜爱的漫画阅读品牌，累计服务超过百万用户。
                </p>
              </div>

              <div className="bg-background-100 rounded-lg p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-full mb-4">
                  <i className="ri-award-line text-xl text-accent-500"></i>
                </div>
                <h2 className="text-lg font-heading text-foreground-900 mb-3">
                  我们的优势
                </h2>
                <ul className="space-y-2 text-sm text-foreground-600">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-accent-500 mt-0.5 w-4 h-4 flex items-center justify-center shrink-0"></i>
                    <span>5000+精选漫画资源，题材丰富多样</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-accent-500 mt-0.5 w-4 h-4 flex items-center justify-center shrink-0"></i>
                    <span>高清画质，极致阅读体验</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-accent-500 mt-0.5 w-4 h-4 flex items-center justify-center shrink-0"></i>
                    <span>每日更新，追更不等待</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-accent-500 mt-0.5 w-4 h-4 flex items-center justify-center shrink-0"></i>
                    <span>多端适配，随时随地阅读</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-4">
              读者口碑
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-10">
              来自真实读者的评价与反馈
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  name: "漫画爱好者小王",
                  text: "羞羞色漫是我用过最好的漫画阅读平台！画质清晰，更新及时，分类也很丰富。每天都会上来看看有没有新的更新，已经成了生活习惯。",
                  rating: 5,
                },
                {
                  name: "资深读者小李",
                  text: "作为一个看了十几年漫画的老读者，羞羞色漫的漫画资源品质真的让我惊喜。推荐的作品都很有水准，排版也很舒服，强烈推荐！",
                  rating: 5,
                },
                {
                  name: "都市白领小张",
                  text: "上班路上和午休时间都会用羞羞色漫看几话漫画，多端同步非常方便。最喜欢恋爱和都市题材的漫画，画面和剧情都很棒。",
                  rating: 5,
                },
              ].map((review, i) => (
                <div key={i} className="bg-background-50 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(review.rating)].map((_, j) => (
                      <i
                        key={j}
                        className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{review.text}&rdquo;
                  </p>
                  <p className="text-xs font-medium text-foreground-800">
                    —— {review.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-4">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-10">
              关于羞羞色漫的常见疑问解答
            </p>

            <div className="space-y-3">
              {faqs.map((faq, i) => (
                <details
                  key={i}
                  className="group bg-background-100 rounded-lg overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-200 transition-colors duration-200">
                    <span className="text-sm font-medium text-foreground-800 pr-4">
                      {faq.q}
                    </span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 w-4 h-4 flex items-center justify-center shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-4">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8">
              有任何问题或建议？请随时与我们联系，我们会在24小时内回复
            </p>

            <form
              className="space-y-4 bg-background-50 rounded-lg p-6"
              data-readdy-form=""
              method="POST"
              action="https://readdy.ai/api/form/d9th1et3pcjqs2fcse50"
              onSubmit={handleSubmit}
            >
              <div>
                <label
                  htmlFor="contact-name"
                  className="block text-sm font-medium text-foreground-700 mb-1.5"
                >
                  您的姓名
                </label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  required
                  className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors duration-200"
                  placeholder="请输入您的姓名"
                />
              </div>

              <div>
                <label
                  htmlFor="contact-email"
                  className="block text-sm font-medium text-foreground-700 mb-1.5"
                >
                  电子邮箱
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  required
                  className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors duration-200"
                  placeholder="请输入您的电子邮箱"
                />
              </div>

              <div>
                <label
                  htmlFor="contact-message"
                  className="block text-sm font-medium text-foreground-700 mb-1.5"
                >
                  留言内容
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={5}
                  maxLength={500}
                  required
                  className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors duration-200 resize-none"
                  placeholder="请输入您的留言内容（不超过500字）"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1">
                  最多500个字符
                </p>
              </div>

              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />

              <button
                type="submit"
                disabled={formStatus === "loading"}
                className="w-full px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {formStatus === "loading" ? "发送中..." : "发送留言"}
              </button>

              {formMessage && (
                <p className={`text-sm text-center ${formStatus === "success" ? "text-green-600" : "text-red-500"}`}>
                  {formMessage}
                </p>
              )}
            </form>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于羞羞色漫 - 精选漫画资源汇聚平台",
            description:
              "羞羞色漫是国内领先的成人漫画在线阅读平台，为18岁以上成年用户提供海量高清漫画资源。了解品牌介绍、读者口碑及联系方式。",
            url: "https://xiuxiuse.com/about",
            isPartOf: {
              "@type": "WebSite",
              name: "羞羞色漫",
              url: "https://xiuxiuse.com",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </>
  );
}